import store from '@/store';
import router from '..';
import { CLEAR_ERRORMSG } from '@/store/action_types';
import { RouteLocationNormalized } from 'vue-router';
import { resetLoaders } from '@/utils/loaders';
import {
  DASHBOARD_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  LOGIN_ROUTE,
  RESET_PASSWORD_ROUTE,
  SIGNUP_ROUTE,
} from '@/router/routes';

export const ifAuthDeny = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: Function
) => {
  store.dispatch(CLEAR_ERRORMSG);
  resetLoaders();

  const sessionToken = store.getters.sessionToken;
  const accountData = store.getters.account.data;

  if (sessionToken == null || accountData == null) {
    if (to.name === SIGNUP_ROUTE) {
      next();
    }

    if (to.name === FORGOT_PASSWORD_ROUTE) {
      next();
    }

    if (to.name === RESET_PASSWORD_ROUTE) {
      next();
    }

    if (to.name !== LOGIN_ROUTE) {
      next({ name: LOGIN_ROUTE });
    } else {
      next(); // Prevent redirect loop
    }
    return;
  }

  next();
};
